// extracted by mini-css-extract-plugin
export default {"root":"Q9H5L7n1lEhzBCtqosnw","footer":"gcxisRXjLzXDU2YOZeCq","proceed":"CkgM18SJbV8ILPLnZUCQ","btn":"lkVYPDjXuyajur4TQ6IH","loader":"LjwLMDR0eSKKGZwbDmKj"};